<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="plus"
      text="Dodaj novu"
      type="default"
      (onClick)="onAddClick()">
    </dx-button>
    
    <dx-button
      icon="edit"
      text="Izmijeni"
      type="default"
      [disabled]="!selectedDrzava"
      (onClick)="onEditClick()">
    </dx-button>
    
    <dx-button
      icon="trash"
      text="Obriši"
      type="danger"
      [disabled]="!selectedDrzava"
      (onClick)="onDeleteClick()">
    </dx-button>
    
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid
    #drzaveGrid
    id="drzaveGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true"
    (onRowClick)="onDrzavaRowClick($event)">
    
    <dxi-column 
      dataField="naziv" 
      caption="Država" 
      [minWidth]="200"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Dodaj Novu Državu"
  [(visible)]="isCreatePopupVisible"
  (onHiding)="onCreatePopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="drzavaForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="naziv"
          placeholder="Unesite naziv države"
          [isValid]="!drzavaForm.get('naziv')?.errors"
          validationMessage="Naziv države je obavezan">
        </dx-text-box>
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Kreiraj"
          type="default"
          (onClick)="createDrzava()"
          [disabled]="!drzavaForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<!-- Edit Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Izmijeni Državu"
  [(visible)]="isEditPopupVisible"
  (onHiding)="onEditPopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="drzavaForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="naziv"
          placeholder="Unesite naziv države"
          [isValid]="!drzavaForm.get('naziv')?.errors"
          validationMessage="Naziv države je obavezan">
        </dx-text-box>
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Ažuriraj"
          type="default"
          (onClick)="updateDrzava()"
          [disabled]="!drzavaForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isEditPopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>